import axiosInstance from '../common/axios';
const backendUrl = process.env.REACT_APP_BACKEND_URL;



export async function saveProductReview(data) {
  const res = await axiosInstance.post(`${backendUrl}/api/reviews`, data);
  return res.data;
}

export async function approveProductReview(id) {

  const res = await axiosInstance.put(`${backendUrl}/api/reviews/approve/${id}`);
  return res.data;
}

export async function rejectProductReview(id) {

  const res = await axiosInstance.put(`${backendUrl}/api/reviews/reject/${id}`);
  return res.data;
}

export async function getProductReview(productId) {
  return axiosInstance.get(`${backendUrl}/api/reviews/product/${productId}`);
}
 

export async function getUserProductReviews(userId) {
  return axiosInstance.get(`${backendUrl}/api/reviews/users/${userId}`);
}

export async function fetchProductReviews() {
     return axiosInstance.get(`${backendUrl}/api/reviews`);
    }